import { ReactImageGalleryItem } from "react-image-gallery";
import _1_1 from "./assets/png/1 instalacje elektryczne/1.1.jpg";
import _1_2 from "./assets/png/1 instalacje elektryczne/1.2.jpg";
import _1_3 from "./assets/png/1 instalacje elektryczne/1.3.jpg";
import _1_4 from "./assets/png/1 instalacje elektryczne/1.4.jpg";
import _1_5 from "./assets/png/1 instalacje elektryczne/1.5.jpg";

import _2_1 from "./assets/png/2 alarmy/2.1.jpg";
import _2_2 from "./assets/png/2 alarmy/2.2.jpg";
import _2_3 from "./assets/png/2 alarmy/2.3.jpg";
import _2_4 from "./assets/png/2 alarmy/2.4.jpg";
import _2_5 from "./assets/png/2 alarmy/2.5.jpg";
import _2_6 from "./assets/png/2 alarmy/2.6.jpg";
import _2_7 from "./assets/png/2 alarmy/2.7.jpg";
import _2_8 from "./assets/png/2 alarmy/2.8.jpg";
import _2_9 from "./assets/png/2 alarmy/2.9.jpg";

import _3_1 from "./assets/png/3 kamery/3.1.jpg";
import _3_10 from "./assets/png/3 kamery/3.10.jpg";
import _3_2 from "./assets/png/3 kamery/3.2.jpg";
import _3_3 from "./assets/png/3 kamery/3.3.jpg";
import _3_4 from "./assets/png/3 kamery/3.4.jpg";
import _3_5 from "./assets/png/3 kamery/3.5.jpg";
import _3_6 from "./assets/png/3 kamery/3.6.jpg";
import _3_7 from "./assets/png/3 kamery/3.7.jpg";
import _3_8 from "./assets/png/3 kamery/3.8.jpg";
import _3_9 from "./assets/png/3 kamery/3.9.jpg";

import _4_1 from "./assets/png/4 kontrola dostepu/4.1.jpg";
import _4_2 from "./assets/png/4 kontrola dostepu/4.2.jpg";
import _4_3 from "./assets/png/4 kontrola dostepu/4.3.jpg";
import _4_4 from "./assets/png/4 kontrola dostepu/4.4.jpg";
import _4_5 from "./assets/png/4 kontrola dostepu/4.5.jpg";

import _5_1 from "./assets/png/5 oddymianie i ssp/5.1.jpg";
import _5_2 from "./assets/png/5 oddymianie i ssp/5.2.jpg";
import _5_3 from "./assets/png/5 oddymianie i ssp/5.3.jpg";
import _5_4 from "./assets/png/5 oddymianie i ssp/5.4.jpg";

import _6_1 from "./assets/png/6 sieci strukturalne/6.1.jpg";
import _6_10 from "./assets/png/6 sieci strukturalne/6.10.jpg";
import _6_2 from "./assets/png/6 sieci strukturalne/6.2.jpg";
import _6_3 from "./assets/png/6 sieci strukturalne/6.3.jpg";
import _6_4 from "./assets/png/6 sieci strukturalne/6.4.jpg";
import _6_5 from "./assets/png/6 sieci strukturalne/6.5.jpg";
import _6_6 from "./assets/png/6 sieci strukturalne/6.6.jpg";
import _6_7 from "./assets/png/6 sieci strukturalne/6.7.jpg";
import _6_8 from "./assets/png/6 sieci strukturalne/6.8.jpg";
import _6_9 from "./assets/png/6 sieci strukturalne/6.9.jpg";
import { t } from "i18next";

export const INSTALLATIONS = [
  {
    img: _1_1,
    title: { pl: "Szlabany w zakładzie Nowak", en: "Gate barriers at the Nowak plant" }
  },
  {
    img: _1_2,
    title: { pl: "Instalacja elektryczna w SOT pod Słupskiem", en: "Electrical installation in SOT near Słupsk" }
  },
  {
    img: _1_3,
    title: { pl: "Rozdzielnia elektryczna w zakładzie produkcyjnym pod Gdańskim lotniskiem", en: "Electrical switchgear in a production plant near Gdańsk airport" }
  },
  {
    img: _1_4,
    title: { pl: "Instalacja w DRE Rowery w Gdyni", en: "Installation at DRE Rowery in Gdynia" }
  },
  {
    img: _1_5,
    title: { pl: "Szlaban w zakładach STOKOTY w Elblągu", en: "Gate barrier at the STOKOTY plant in Elbląg" }
  },
]

export const ALARMS = [
  {
    img: _2_1,
    title: { pl: "Centrala SATEL INTEGRA przygotowana do integracji z smarthome GRENTON", en: "SATEL INTEGRA alarm panel prepared for integration with GRENTON smart home" },
  },
  {
    img: _2_2,
    title: { pl: "RISCO w sieci sklepów LIBERO", en: "RISCO in the LIBERO store chain" },
  },
  {
    img: _2_3,
    title: { pl: "Instalacja w sieci sklepów LIBERO", en: "Installation in the LIBERO store chain" },
  },
  {
    img: _2_4,
    title: { pl: "Instalacja w sieci sklepów LIBERO", en: "Installation in the LIBERO store chain" },
  },
  {
    img: _2_5,
    title: { pl: "Instalacja w sieci sklepów LIBERO", en: "Installation in the LIBERO store chain" },
  },
  {
    img: _2_6,
    title: { pl: "Instalacja w salonie SUBARU", en: "Installation in a SUBARU showroom" },
  },
  {
    img: _2_7,
    title: { pl: "Instalacja w salonie SUBARU", en: "Installation in a SUBARU showroom" },
  },
  {
    img: _2_8,
    title: { pl: "Instalacja w salonie SUBARU", en: "Installation in a SUBARU showroom" },
  },
  {
    img: _2_9,
    title: { pl: "Instalacja w salonie SUBARU", en: "Installation in a SUBARU showroom" },
  }
]

export const CCTV = [
  { img: _3_1, title: { pl: "Zabezpieczenie placu salon SUBARU", en: "Security of the SUBARU showroom lot" } },
  { img: _3_2, title: { pl: "Zabezpieczenie placu salon SUBARU", en: "Security of the SUBARU showroom lot" } },
  { img: _3_3, title: { pl: "Zabezpieczenie placu salon SUBARU", en: "Security of the SUBARU showroom lot" } },
  { img: _3_4, title: { pl: "Zabezpieczenie domów letniskowych Szemud/Sulęczyno", en: "Security of holiday homes in Szemud/Sulęczyno" } },
  { img: _3_5, title: { pl: "Zabezpieczenie domów letniskowych Szemud/Sulęczyno", en: "Security of holiday homes in Szemud/Sulęczyno" } },
  { img: _3_6, title: { pl: "Zabezpieczenie domów letniskowych Szemud/Sulęczyno", en: "Security of holiday homes in Szemud/Sulęczyno" } },
  { img: _3_7, title: { pl: "Zabezpieczenie domów letniskowych Szemud/Sulęczyno", en: "Security of holiday homes in Szemud/Sulęczyno" } },
  { img: _3_8, title: { pl: "Kamera PTZ HIK", en: "HIK PTZ camera" } },
  { img: _3_9, title: { pl: "Kamera PTZ HIK", en: "HIK PTZ camera" } },
  { img: _3_10, title: { pl: "Zabezpieczenie SOT pod Słupskiem", en: "Security of SOT near Słupsk" } },
]

export const ACCESS_CONTROL = [
  { img: _4_1, title: { pl: "kontrola dostępu DAHUA zintegrowana z bramą wjazdową", en: "DAHUA access control integrated with the entrance gate" } },
  { img: _4_2, title: { pl: "kontrola dostępu ROGER do nadzoru call center", en: "ROGER access control for call center supervision" } },
  { img: _4_3, title: { pl: "kontrola dostępu ROGER do nadzoru call center", en: "ROGER access control for call center supervision" } },
  { img: _4_4, title: { pl: "kontrola dostępu ROGER do nadzoru call center", en: "ROGER access control for call center supervision" } },
  { img: _4_5, title: { pl: "kontrola dostępu wielorodzinnej posiadłości", en: "Access control for a multi-family property" } },
]

export const FIRE_PROTECTION = [
  { img: _5_1, title: { pl: "SSP hotelu w Gdańsku", en: "Fire alarm system of a hotel in Gdańsk" } },
  { img: _5_2, title: { pl: "Oddymianie Grawitacyjne nowego przedszkola w Gdańsku", en: "Gravity smoke ventilation of a new kindergarten in Gdańsk" } },
  { img: _5_3, title: { pl: "Oddymianie Grawitacyjne nowego przedszkola w Gdańsku", en: "Gravity smoke ventilation of a new kindergarten in Gdańsk" } },
  { img: _5_4, title: { pl: "Oddymianie Grawitacyjne nowego przedszkola w Gdańsku", en: "Gravity smoke ventilation of a new kindergarten in Gdańsk" } },
]

export const NETWORKS = [
  { img: _6_1, title: { pl: "sieć strukturalna SOT pod Słupskiem", en: "Structured cabling network for SOT near Słupsk" } },
  { img: _6_2, title: { pl: "sieć strukturalna SOT pod Słupskiem", en: "Structured cabling network for SOT near Słupsk" } },
  { img: _6_3, title: { pl: "sieć strukturalna SOT pod Słupskiem", en: "Structured cabling network for SOT near Słupsk" } },
  { img: _6_4, title: { pl: "sieć strukturalna w centrum handlowym w Gdańsku", en: "Structured cabling in a shopping center in Gdańsk" } },
  { img: _6_5, title: { pl: "sieć strukturalna w centrum handlowym w Gdańsku", en: "Structured cabling in a shopping center in Gdańsk" } },
  { img: _6_6, title: { pl: "sieć strukturalna w biurowcu w Gdańsku", en: "Structured cabling in an office building in Gdańsk" } },
  { img: _6_7, title: { pl: "sieć strukturalna w biurowcu w Gdańsku", en: "Structured cabling in an office building in Gdańsk" } },
  { img: _6_8, title: { pl: "sieć strukturalna w biurowcu w Gdańsku", en: "Structured cabling in an office building in Gdańsk" } },
  { img: _6_9, title: { pl: "sieć strukturalna w biurowcu w Gdańsku", en: "Structured cabling in an office building in Gdańsk" } },
  { img: _6_10, title: { pl: "sieć strukturalna w biurowcu w Gdańsku", en: "Structured cabling in an office building in Gdańsk" } },
]

export type GalleryItem = {
  path?: string,
  img: string,
  title: { pl: string, en: string }
}

export function toGallery(items: GalleryItem[]) {
  return items.map(e => {
    return {
      original: e.img,
      originalTitle: e.title as any,
      description: e.path
    } as ReactImageGalleryItem
  });
}